import { render, staticRenderFns } from "./GraphForm.vue?vue&type=template&id=06b256c0&scoped=true&"
import script from "./GraphForm.vue?vue&type=script&lang=js&"
export * from "./GraphForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b256c0",
  null
  
)

export default component.exports